// Shell URLs use Storybook's shape, so links and bookmarks survive a move:
//   ?path=/docs/forms-toggle--docs
//   ?path=/story/forms-toggle--playground&globals=theme:dark&args={"label":"Hi"}

export function readUrl() {
  const params = new URLSearchParams(location.search);
  const path = params.get('path') ?? '';
  const m = path.match(/^\/(docs|story)\/([^/?#]+)/);
  const globals = {};
  for (const pair of (params.get('globals') ?? '').split(';').filter(Boolean)) {
    const [k, ...rest] = pair.split(':');
    globals[k] = decodeURIComponent(rest.join(':'));
  }
  let args = null;
  try {
    args = params.get('args') ? JSON.parse(params.get('args')) : null;
  } catch {}
  return { id: m ? m[2] : null, viewMode: m ? m[1] : null, globals, args };
}

export function writeUrl({ id, viewMode, globals, args }, { replace = false } = {}) {
  const params = new URLSearchParams();
  if (id) params.set('path', `/${viewMode ?? (id.endsWith('--docs') ? 'docs' : 'story')}/${id}`);
  const g = Object.entries(globals ?? {}).filter(([, v]) => v != null);
  if (g.length) params.set('globals', g.map(([k, v]) => `${k}:${v}`).join(';'));
  if (args && Object.keys(args).length) params.set('args', JSON.stringify(args));
  const search = params.toString().replace(/%2F/g, '/').replace(/%3A/g, ':').replace(/%3B/g, ';');
  const url = `${location.pathname}${search ? '?' + search : ''}${location.hash}`;
  if (url === `${location.pathname}${location.search}${location.hash}`) return;
  history[replace ? 'replaceState' : 'pushState'](null, '', url);
}
